import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=32a3b07c&"
import script from "./CardItem.vue?vue&type=script&lang=js&"
export * from "./CardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-mobile-web/cafe-mobile-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a3b07c')) {
      api.createRecord('32a3b07c', component.options)
    } else {
      api.reload('32a3b07c', component.options)
    }
    module.hot.accept("./CardItem.vue?vue&type=template&id=32a3b07c&", function () {
      api.rerender('32a3b07c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/article_widget/components/CardItem.vue"
export default component.exports